import { Box, Button, Chip, Typography, useTheme } from '@mui/material';
import { convertConstStringToText } from '@ui-framework/index';
import CustomIcons from './IconLibrary';

export const dispatchEventStatusConfig = theme => ({
  PENDING_ACCEPTANCE: {
    label: 'Pending Acceptance',
    borderColor: theme.palette.primary.dark,
    textColor: 'warning',
    Icon: CustomIcons.DISPATCH_EVENT_STATUS_PENDING_ACCEPTANCE,
    iconColor: 'warning',
  },
  ACCEPTED: {
    label: 'Accepted',
    borderColor: theme.palette.primary.dark,
    textColor: 'success',
    Icon: CustomIcons.DISPATCH_EVENT_STATUS_ACCEPTED,
    iconColor: 'success',
  },
  REJECTED: {
    label: 'Rejected',
    borderColor: theme.palette.primary.dark,
    textColor: 'error',
    Icon: CustomIcons.DISPATCH_EVENT_STATUS_REJECTED,
    iconColor: 'error',
  },
  ACCEPTED_WITH_CONDITIONS: {
    label: 'Accepted With Conditions',
    borderColor: theme.palette.primary.dark,
    textColor: 'success',
    Icon: CustomIcons.DISPATCH_EVENT_STATUS_ACCEPTED_WITH_CONDITIONS,
    iconColor: 'success',
  },
  REVOKED: {
    label: 'Revoked',
    borderColor: theme.palette.primary.dark,
    textColor: 'error',
    Icon: CustomIcons.DISPATCH_EVENT_STATUS_REVOKED,
    iconColor: 'error',
  },
  ASSIGNED: {
    label: 'Assigned',
    borderColor: theme.palette.primary.dark,
    textColor: 'success',
    Icon: CustomIcons.DISPATCH_EVENT_STATUS_ASSIGNED,
    iconColor: 'success',
  },
  SCHEDULED: {
    label: 'Scheduled',
    borderColor: theme.palette.primary.dark,
    textColor: 'success',
    Icon: CustomIcons.DISPATCH_EVENT_STATUS_SCHEDULED,
    iconColor: 'success',
  },
  ALL: {
    label: 'All',
    borderColor: theme.palette.primary.dark,
    textColor: 'primary',
  },
});

function DispatchEventStatus({
  value,
  count = 0,
  showCount = false,
  withIcon = false,
  onClick = () => undefined,
  selected = false,
  showAsText = false,
  small = false,
}) {
  const theme = useTheme();
  const config = dispatchEventStatusConfig(theme);

  const smallText = small ? { fontSize: '0.9em' } : {};

  if (config?.[value]) {
    const { Icon, label, textColor, iconColor } = config[value];
    return showAsText ? (
      <Typography sx={{ color: theme.palette[textColor]?.main, ...smallText }}>
        {label}
      </Typography>
    ) : (
      <Button
        variant={selected ? 'contained' : 'outlined'}
        color={textColor}
        onClick={onClick}
        size="small"
        sx={{ minWidth: 0 }}>
        <Box display="flex" alignItems="center">
          {withIcon && Icon && (
            <Icon color={iconColor} fontSize="small" sx={{ mr: 1 }} />
          )}
          <span>{label}</span>
        </Box>
        {showCount && (
          <Chip
            sx={{
              ml: 1,
              background: '#ffffff',
              color: '#000000',
              fontWeight: 'bold',
            }}
            label={count}
            size="small"
            color="secondary"
            variant="outlined"
          />
        )}
      </Button>
    );
  }

  return showAsText ? (
    <Typography sx={{ ...smallText }} color="inherit">
      {convertConstStringToText(value)}
    </Typography>
  ) : (
    <Button
      variant={selected ? 'contained' : 'outlined'}
      color="inherit"
      size="small"
      sx={{ minWidth: 0 }}>
      <Box display="flex" alignItems="center">
        <span>{convertConstStringToText(value)}</span>
      </Box>
      {showCount && (
        <Chip
          sx={{
            ml: 1,
            background: '#ffffff',
            color: '#000000',
            fontWeight: 'bold',
          }}
          label={count}
          size="small"
          color="secondary"
          variant="outlined"
        />
      )}
    </Button>
  );
}

export default DispatchEventStatus;
